import * as React from 'react';
import { Card, Spinner } from '@blueprintjs/core';
import { TranslatedMessage } from './translation';
import { TLCode } from '../../common/enums';
import styled from '@emotion/styled';

export interface TitledCardProps {
  title: TLCode | string;
  isLoading?: boolean;
  renderRightComponent?: () => JSX.Element;
}

const HeaderContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
});

const Title = styled.h2({
  marginRight: '5px',
  marginTop: 0,
  marginBottom: 2,
});

class TitledCard extends React.Component<TitledCardProps> {
  public render() {
    const { isLoading, renderRightComponent, children, title } = this.props;

    return (
      <Card
        style={{
          margin: 10,
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          flex: 1,
        }}
      >
        <HeaderContainer>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Title>{typeof title === 'string' ? title : <TranslatedMessage id={title as TLCode} />}</Title>
            {isLoading && <Spinner size={15} />}
          </div>
          {renderRightComponent && renderRightComponent()}
        </HeaderContainer>
        {children}
      </Card>
    );
  }
}

export default TitledCard;
